class CarouselWithTextV2 extends HTMLElement {
    constructor() {
        super();
        const originalThis = this;
        this.config = new TinySliderConfig().generateConfig(this);
        this.slider = tns(this.config);
        this.textSlider = tns({
            ...this.config,
            container: '.carousel-with-text-v2__content',
            nav: false,
            controls: false,
            mode: 'gallery',
        });

        this.slider.events.on('indexChanged', this.onChange.bind(this));
        this.textSlider.events.on('indexChanged', this.onChange.bind(this));

        this.textSliderButtons = document.querySelectorAll('.tabs--name');
        this.textSliderButtons.forEach((button) => {
            button.addEventListener('click', function (e) {
                originalThis.tabClickChangeSlider(e);
            });
        });
    }

    onChange(event) {
        if (this.slider.getInfo().index != event.index) this.slider.goTo(event.index);
        if (this.textSlider.getInfo().index != event.index) this.textSlider.goTo(event.index);
        this.toggleActiveTab(event.index + 1);
    }

    tabClickChangeSlider(event) {
        const changeToSlide = event.target.getAttribute('data-slide');
        this.toggleActiveTab(changeToSlide);
        this.slider.goTo(changeToSlide - 1);
        this.textSlider.goTo(changeToSlide - 1);
    }

    toggleActiveTab(newSlide) {
        document.querySelectorAll('.tabs--name.button--active').forEach((activeTab) => {
            activeTab.classList.remove('button--active');
        });
        this.textSliderButtons.forEach((button) => {
            if (button.getAttribute('data-slide') == newSlide) button.classList.add('button--active');
        });
    }
}

customElements.define('carousel-with-text-v2', CarouselWithTextV2);
